import React from 'react';
import { AritoIconActionButton } from '@/components/custom/arito/local-action-button';

export type ActionButtonFormType = 'add' | 'edit';

interface ActionButtonFormProps {
  onAddForm?: () => void;
  onEditForm?: () => void;
}

export const getActionButtonForm = (type: ActionButtonFormType, props: ActionButtonFormProps): React.ReactNode => {
  const { onAddForm, onEditForm } = props;
  switch (type) {
    case 'add':
      return <AritoIconActionButton title='Thêm' icon={7} onClick={onAddForm} disabled={!onAddForm} />;

    case 'edit':
      return <AritoIconActionButton title='Sửa' icon={9} onClick={onEditForm} disabled={!onEditForm} />;

    default:
      return null;
  }
};
